import React from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  border-style: none;
  color: white;
  border-radius: 30px;
  background: ${(props) => props.theme.colors.primary};
  font-weight: 500;
  display: block;
  padding: 1rem;
  width: 100%;
  font-size: 1.1rem;
  cursor: pointer;
  user-select: none;

  &:hover {
    opacity: 0.9;
  }

  &.size-s {
    padding: 0.31rem 0.42rem;
    font-size: 0.75rem;
  }

  &.destructive {
    background: ${(props) => props.theme.colors.danger};
  }
`;

interface Props {
  title: string;
  onClick: () => void;
  className?: string;
  size?: "s" | "m";
  destructive?: boolean;
}

const Button: React.FC<Props> = ({ title, size = "m", onClick, className = "", destructive }) => {
  return (
    <StyledButton onClick={onClick} className={`${className} size-${size} ${destructive && "destructive"}`}>
      {title}
    </StyledButton>
  );
};

export default Button;
